import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import { Spinner } from 'construct-ui';
import { getRandomPingDetail } from "../../../models/announcement/randomPing.model";
import ViewBase from '../../view-base.view';
import RecipientView from './randomPing-recipent-list.dialog';
import moment from "moment";

export default function AnnouncementDetailView(vnode) {
  ViewBase.call(this);
  let isLoading = false;
  let randomPingDetails = [];

  const loadData = () => {
    isLoading = true;
    const params = {
      randomPingHeader: vnode.attrs.selectedRandomPingID
    }
    getRandomPingDetail(params).then((result) => {
      isLoading = false;
      randomPingDetails = result;
      const total = result.totalCount;
      const data = [{
        type: "Verified",
        value: result.verifiedCount
      }, {
        type: "Unverified",
        value: result.unverifiedCount
      }, {
        type: "Rejected",
        value: result.rejectCount
      }, {
        type: "No Response",
        value: result.noResponseCount
      }];
      loadPieChar(data, total);
    }).catch((error) => {
      isLoading = false;
      this.handleError(error);
    })
  }

  const loadPieChar = (data, total) => {
    const root = am5.Root.new("chartdiv");

    // Formatter
    root.numberFormatter.set("numberFormat", "#,###");

    // Themes
    root.setThemes([
      am5themes_Responsive.new(root),
      am5themes_Animated.new(root)
    ]);

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {})
    );
    // Create series
    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        name: "Series",
        valueField: "value",
        categoryField: "type",
        alignLabels: false,
        radius: am5.percent(90),
        innerRadius: am5.percent(60),
      })
    );
    // series.ticks.template.set("visible", false);
    series.get("colors").set("colors", [
      am5.color(0x97D654),
      am5.color(0xFEB545),
      am5.color(0xFE4335),
      am5.color(0xa1a5b7)
    ]);
    series.data.setAll(data);

    const totalLabel = root.tooltipContainer.children.push(am5.Label.new(root, {
      x: am5.percent(50),
      y: am5.percent(53),
      centerX: am5.p50,
      centerY: am5.p50,
      fill: am5.color(0x000000),
      fontSize: 12,
      textAlign: "left"
    }));
    totalLabel.set("text", "[fontSize: 12px]Total: [bold]" + total + "[/][/]");
  }

  // let _dialogClosed = () => {
  //   isMsgOpen = false;
  // }

  return {
    oninit: function (vnode) {
      if (vnode.attrs.selectedRandomPingID) {
        loadData();
      }
    },
    view: (vnode) => {
      return [m(Spinner, {
        active: isLoading,
        background: true,
        fill: true,
        size: 'xl',
      }),
      m('h4', randomPingDetails.title),
      m('.row.gap-2',
        m('.col-7.pe-0',
          m('.card',
            m('.row',
              m('.col-sm-7.pe-0',
                m("#chartdiv.ac-container-hide-logo", { style: "height: 200px; width:170px; margin:0 auto;" }),
              ),
              m('.col-sm-5.ps-0',
                m('ul.list-group',
                  { style: { "margin-top": "6px", "margin-right": "5px" } },
                  m('li.list-group-item.d-flex.justify-content-between',
                    m('b', 'Total'),
                    m('b', randomPingDetails.totalCount)
                  ),
                  m('li.list-group-item.d-flex.justify-content-between',
                    { style: { "background-color": "#97D654" } },
                    m('span', 'Verified'),
                    m('span', randomPingDetails.verifiedCount)
                  ),
                  m('li.list-group-item.d-flex.justify-content-between',
                    { style: { "background-color": "#FEB545" } },
                    m('span', 'Unverified'),
                    m('span', randomPingDetails.unverifiedCount)
                  ),
                  m('li.list-group-item.d-flex.justify-content-between',
                    { style: { "background-color": "#FE4335" } },
                    m('span', 'Rejected'),
                    m('span', randomPingDetails.rejectCount)
                  ),
                  m('li.list-group-item.d-flex.justify-content-between',
                    { style: { "background-color": "#a1a5b7" } },
                    m('span', 'No Response'),
                    m('span', randomPingDetails.noResponseCount)
                  ),
                )
              )
            ),
          )
        ),
        m('.col.ps-0.d-flex',
          m('.card.flex-grow-1',
            m('.card-body',
              m('.row',
                m('.col-sm-4',
                  m('p.font-weight-bold', { 'class': 'mb-0' }, 'Username'
                  )
                ),
                m('.col-sm-8',
                  m('p', randomPingDetails["userName"] || "N/A")
                ),
                // m('hr.divider-line')
              ),
              m('.row',
                m('.col-sm-4',
                  m('p.font-weight-bold', { 'class': 'mb-0' }, 'Ping Type'
                  )
                ),
                m('.col-sm-8',
                  m('p', randomPingDetails["pingType"])
                ),
                // m('hr.divider-line')
              ),
              m('.row',
                m('.col-sm-4',
                  m('p.font-weight-bold', { 'class': 'mb-0' }, 'Start Time'
                  )
                ),
                m('.col-sm-8',
                  m('p', moment(randomPingDetails["startTime"]).format("YYYY-MM-DD HH:mm:ss"))
                ),
                // m('hr.divider-line')
              ),
              m('.row',
                m('.col-sm-4',
                  m('p.font-weight-bold', { 'class': 'mb-0' }, 'End Time'
                  )
                ),
                m('.col-sm-8',
                  m('p', moment(randomPingDetails["endTime"]).format("YYYY-MM-DD HH:mm:ss"))
                ),
                // m('hr.divider-line')
              ),
              m('.row',
                m('.col-sm-4',
                  m('p.font-weight-bold', { 'class': 'mb-0' }, 'Create Date'
                  )
                ),
                m('.col-sm-8',
                  m('p.mb-0', randomPingDetails["createDate"] ? moment(randomPingDetails["createDate"]).format("YYYY-MM-DD HH:mm:ss") : "N/A")
                ),
                // m('hr.divider-line')
              ),
            ),
          ),
        )
      ),
      m('.mt-4',
        m(RecipientView, { selectedRandomPingID: vnode.attrs.selectedRandomPingID })
      ),
      this.getBaseViews()];
    }
  }
}
